import { useContext } from 'react'
import { useSelector } from 'react-redux'

import { useForm, useLatestEntity, useThunkDispatch } from '@domain-group/react-hooks'

import { mergeAndStringifyEntityObjects } from '@functions/entity'

import defaultFormState, { requiredFields } from '@models/fontFamily'

import PageContext from '@contexts/pageContext'

import * as fontFamilyActions from '@redux/modules/fontFamily'

export const generateUrls = () => ({
  fontFamiliesIndexUrl: '#/systemManager/fonts',
})

const createFontFamily = (params) => {
  const { fontFamilyParams, dispatch, requestOptions } = params
  const { createFontFamily: createFn } = fontFamilyActions

  return dispatch(createFn(fontFamilyParams, requestOptions))
}

const updateFontFamily = (params) => {
  const {
    fontFamily, fontFamilyParams, dispatch, requestOptions,
  } = params
  const { updateFontFamily: updateFn } = fontFamilyActions

  const updatedParams = mergeAndStringifyEntityObjects(fontFamily, fontFamilyParams, [])

  return dispatch(updateFn(updatedParams, requestOptions))
}

const createOrEditFontFamily = params => new Promise((resolve, reject) => {
  const { fontFamily, showCreateOrEditFontFamilyModal } = params

  if (showCreateOrEditFontFamilyModal){
    const payload = {
      fontFamily,
    }

    showCreateOrEditFontFamilyModal(payload)

    resolve({ success: true, result: payload })
  }

  reject(new Error('showCreateOrEditFontFamilyModal not defined in PageContext callbacks'))
})

export function useFontFamilyForm(fontFamily = {}, options = {}){
  const { customRequiredFields = [], validateOn } = options

  const fontFamilyForm = useForm(
    defaultFormState,
    { entity: fontFamily, requiredFields: [...requiredFields, ...customRequiredFields], validateOn },
    [fontFamily.id, fontFamily.cache_key],
  )

  return fontFamilyForm
}

function useFontFamily(initEntity = {}){
  const { entity: fontFamily } = useLatestEntity(initEntity, 'fontFamilies')

  const dispatch = useThunkDispatch()

  const { callbacks } = useContext(PageContext)
  const { showCreateOrEditFontFamilyModal } = callbacks || {}

  const { creating, updating } = useSelector(reduxState => reduxState.fontFamilies)

  return {
    callbacks: {
      createFontFamily: (fontFamilyParams, requestOptions) => (
        createFontFamily({ fontFamilyParams, dispatch, requestOptions })
      ),
      createOrEditFontFamily: () => createOrEditFontFamily({ fontFamily, showCreateOrEditFontFamilyModal }),
      updateFontFamily: (fontFamilyParams, requestOptions) => updateFontFamily({
        fontFamily, fontFamilyParams, dispatch, requestOptions,
      }),
    },
    creating,
    fontFamily,
    updating,
    urls: generateUrls(),
  }
}

export default useFontFamily
